/**
 * Модуль «Для лёгкого старта»: кнопка открывает чат поддержки.
 */
function initEasyStart() {
    document.querySelectorAll('[data-easy-start-chat]').forEach(function (button) {
        if (button.dataset.easyStartReady === '1') {
            return;
        }

        button.dataset.easyStartReady = '1';
        button.addEventListener('click', function (event) {
            event.preventDefault();
            if (typeof Verbox === 'function') {
                Verbox('openSupport');
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEasyStart);
} else {
    initEasyStart();
}
